import translations from './Languages.js'

type AddressLike = {
    recipientChoice?: {type?: string, place?: string, note?: string, nr?: string, pickupPoint?: {name?: string}} | null
    recipientInstructions?: string
}

/** What the recipient asked for on the Track & Trace page, for the planner and the courier app. */
export function recipientChoiceText(address: AddressLike): string {
    const choice = address?.recipientChoice

    if (choice?.type === 'safePlace') {
        return translations.recipientChoiceSafePlace.NL(`${choice.place || ''}${choice.note ? ` (${choice.note})` : ''}`)
    }

    if (choice?.type === 'neighbour') {
        return translations.recipientChoiceNeighbour.NL(choice.nr || '')
    }

    if (choice?.type === 'pickupPoint') {
        return translations.recipientChoicePickupPoint.NL(choice.pickupPoint?.name || '')
    }

    return ''
}

/** Choice and instructions of the recipient on separate lines, empty when there are none. */
export function recipientWishes(address: AddressLike): string {
    return [recipientChoiceText(address), address?.recipientInstructions ? translations.recipientInstructionsShort.NL(address.recipientInstructions) : ''].filter(Boolean).join('\n')
}
